
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Home, ArrowLeft, AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Check if this might be a tenant invitation link with an invalid token
  const isTenantInvitationPath = location.pathname.startsWith('/tenant-signup/');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="mx-auto w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-muted-foreground" />
          </div>
          <CardTitle className="text-4xl font-bold mb-2">404</CardTitle>
          <CardDescription className="text-xl">
            Oops! Page not found
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          {isTenantInvitationPath ? (
            <div className="bg-muted/50 border border-border rounded-lg p-4 text-sm">
              <p className="font-medium text-foreground mb-2">
                Tenant Invitation Issue
              </p>
              <p className="text-muted-foreground">
                This invitation link may be invalid, expired, or already used. 
                Please contact your landlord for a new invitation.
              </p>
            </div>
          ) : (
            <p className="text-muted-foreground">
              The page you're looking for doesn't exist or may have been moved.
            </p>
          )}
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild variant="default">
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                Go Home
              </Link>
            </Button>
            
            <Button asChild variant="outline">
              <button onClick={() => window.history.back()}>
                <ArrowLeft className="w-4 h-4 mr-2" />
                Go Back
              </button>
            </Button>
          </div>
          
          {isTenantInvitationPath && (
            <div className="mt-6 pt-4 border-t border-border">
              <p className="text-sm text-muted-foreground mb-3">
                Are you a landlord looking to invite tenants?
              </p>
              <Button asChild variant="outline" size="sm">
                <Link to="/login">
                  Sign in to your account
                </Link>
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
